import { render, staticRenderFns } from "./sp_detail.html?vue&type=template&id=1c1d63a0&scoped=true&"
import script from "./sp_detail.vue?vue&type=script&scoped=true&lang=js&"
export * from "./sp_detail.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./sp_detail.scss?vue&type=style&index=0&id=1c1d63a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d63a0",
  null
  
)

export default component.exports